module.exports = __webpack_public_path__ + "img/edge_soft.64ba7a15.webp";